<template>
  <header class="portal-header">
    <div class="page-shell portal-header__top">
      <router-link :to="homeTarget" class="portal-brand">
        <img src="@/assets/logo.svg" alt="AeroCommander" class="portal-brand__logo">
        <div>
          <div class="portal-brand__title">SkyVision</div>
          <div class="portal-brand__subtitle">Портал доступа к видеотрансляциям</div>
        </div>
      </router-link>

      <div class="portal-header__actions">
        <div class="portal-header__welcome">
          <div class="page-eyebrow mb-1">{{ headerEyebrow }}</div>
          <div class="small">Рабочее пространство AeroCommander</div>
        </div>
        <div class="language-select" aria-label="Language selector">
          <button type="button" class="language-chip" @click="changeLanguage('en')">EN</button>
          <button type="button" class="language-chip" @click="changeLanguage('ru')">RU</button>
          <button type="button" class="language-chip" @click="changeLanguage('kz')">KZ</button>
        </div>
      </div>
    </div>
    <NavBar />
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import NavBar from '../components/NavBar.vue';
import { defaultRouteForRole } from '../utils/navigation';

export default {
  components: {
    NavBar,
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'userRole']),
    homeTarget() {
      return this.isAuthenticated ? defaultRouteForRole(this.userRole) : '/login';
    },
    headerEyebrow() {
      if (this.userRole === 'admin') return 'Администратор';
      if (this.userRole === 'operator') return 'Оператор';
      if (['user', 'guest'].includes(this.userRole)) return 'Клиентский портал';
      return 'SkyVision';
    },
  },
  methods: {
    changeLanguage(language) {
      this.$i18n.locale = language;
    }
  }
};
</script>

<style scoped>
.portal-header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: #f8fbff;
  border-bottom: 1px solid #d7e3ef;
}

.portal-header__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 12px 0;
}

.portal-header__actions {
  display: flex;
  align-items: center;
  gap: 18px;
}

.portal-header__welcome {
  text-align: right;
}

.portal-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  text-decoration: none;
}

.portal-brand__logo {
  width: 42px;
  height: 42px;
}

.portal-brand__title {
  font-size: 1.25rem;
  font-weight: 700;
}

.portal-brand__subtitle {
  color: var(--app-text-muted);
  font-size: 0.82rem;
}

.language-select {
  display: flex;
  align-items: center;
  gap: 8px;
}

.language-chip {
  border: 1px solid #d3deeb;
  border-radius: 6px;
  padding: 4px 10px;
  background: #ffffff;
  color: var(--app-text-soft);
  font-size: 0.78rem;
  font-weight: 600;
}

.language-chip:hover {
  border-color: rgba(59, 130, 246, 0.3);
  color: var(--app-accent);
}

@media (max-width: 768px) {
  .portal-header__top {
    flex-direction: column;
    align-items: flex-start;
  }

  .portal-header__actions {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .portal-header__welcome {
    text-align: left;
  }
}
</style>
